import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndrawTakingNotes = (props) => /* @__PURE__ */ _jsxs("svg", {
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 738 544",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M273.316 335.182L120.67 367.357a17.02 17.02 0 01-20.14-13.129L74.334 229.96a17.02 17.02 0 0113.129-20.14l152.646-32.176a17.02 17.02 0 0120.14 13.129l26.194 124.269a17.02 17.02 0 01-13.128 20.14zM87.876 211.775a15.017 15.017 0 00-11.584 17.772l26.194 124.269a15.017 15.017 0 0017.771 11.584l152.646-32.175a15.017 15.017 0 0011.584-17.772l-26.194-124.269a15.017 15.017 0 00-17.771-11.584z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 411",
			d: "M230.625 218.618l-77.038 16.239a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 012-3.254l78.42-16.53c3.061 1.726 2.094 4.935-.153 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 412",
			d: "M233.474 232.131l-77.039 16.239a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 012-3.254l78.42-16.53c3.062 1.726 2.094 4.935-.152 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M141.403 259.574l-23.511 4.956a2.962 2.962 0 01-3.506-2.285l-5.848-27.746a2.962 2.962 0 012.285-3.505l23.511-4.956a2.963 2.963 0 013.506 2.285l5.848 27.745a2.962 2.962 0 01-2.285 3.506z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 414",
			d: "M239.081 259.847l-117.574 24.782a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 011.999-3.254l118.958-25.074c3.062 1.726 2.094 4.935-.153 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 415",
			d: "M241.93 273.364l-117.574 24.782a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 012-3.254l118.957-25.074c3.062 1.726 2.094 4.935-.152 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 416",
			d: "M244.778 286.872l-117.575 24.783a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 012-3.255l118.957-25.074c3.062 1.726 2.094 4.935-.152 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 417",
			d: "M247.627 300.388L130.052 325.17a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 012-3.255l118.957-25.074c3.062 1.726 2.094 4.935-.152 5.409z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 418",
			d: "M250.474 313.897L132.9 338.68a2.73 2.73 0 01-3.23-1.863 2.63 2.63 0 011.999-3.254l118.957-25.075c3.062 1.726 2.095 4.936-.152 5.41z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M269.229 252.03a10.527 10.527 0 00-.683 1.51l-48.134 11.945-8.373-8.663-14.725 10.928 13.333 16.776a8 8 0 009.289 2.428l52.23-21.342a10.497 10.497 0 10-2.937-13.582zM104.932 358.323a10.743 10.743 0 006.378-15.188l33.125-92.067-23.004-4.077-25.327 91.78a10.8 10.8 0 008.828 19.552z",
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M140.228 267.41l-22.713-8.716a4.817 4.817 0 01-2.47-6.863l11.916-21.126a13.377 13.377 0 0124.95 9.66l-5.256 23.597a4.817 4.817 0 01-6.427 3.449z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M191.493 531.175h12.259l5.833-47.288-18.094.001.002 47.287z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.366 527.173l24.143-.001h.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.001z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ffb8b8",
			d: "M122.493 531.175h12.259l5.833-47.288-18.094.001.002 47.287z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M119.366 527.173l24.143-.001h.001a15.386 15.386 0 0115.387 15.386v.5l-39.53.001zM135.345 512.142h-15.514a4.5 4.5 0 01-4.495-4.713l7.37-158.332.463-.013 74.92-1.953 14.66 158.423a4.5 4.5 0 01-4.12 4.91l-17.427 1.394a4.502 4.502 0 01-4.767-3.582L164.145 395.5a1.454 1.454 0 00-1.47-1.2h-.005a1.454 1.454 0 00-1.467 1.212l-21.442 113a4.51 4.51 0 01-4.416 3.63z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 163.765,
			cy: 183.324,
			r: 24.561,
			fill: "#ffb8b8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.53 367.651c-11.707 0-23.73-3.077-33.699-12.175a4.552 4.552 0 01-1.47-3.85c1.068-9.585 6.243-59.08 3.329-92.143a40.02 40.02 0 0112.955-33.304 39.598 39.598 0 0133.962-9.834c.306.054.612.112.918.17 19.664 3.806 33.326 22.004 31.78 42.332-2.256 29.66-4.278 69.779-1.103 92.467a4.493 4.493 0 01-2.414 4.637c-7.225 3.65-25.327 11.7-44.259 11.7z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.579 269.178a4.812 4.812 0 01-2.11-3.412l-2.992-23.99a13.377 13.377 0 0125.754-7.247l9.856 22.16a4.817 4.817 0 01-3.11 6.598l-23.437 6.522a4.811 4.811 0 01-3.961-.631z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M155.19 207.538a17.598 17.598 0 01-6.796-1.23c-.952-.367-1.94-.668-2.889-1.035-8.387-3.24-13.911-12.172-14.109-21.16s4.457-17.713 11.37-23.463 15.864-8.701 24.829-9.384c9.657-.735 20.53 1.714 25.926 9.756 1.437 2.14 2.441 4.738 1.59 7.322a4.686 4.686 0 01-1.32 2.028c-2.41 2.144-4.813.532-7.27.39-3.376-.196-6.408 2.537-7.498 5.739s-.61 6.727.27 9.992a24.962 24.962 0 011.258 6.076 6.108 6.108 0 01-2.531 5.379c-2.11 1.275-4.88.537-6.992-.736s-3.935-3.044-6.216-3.981-5.344-.73-6.671 1.348a7.379 7.379 0 00-.844 2.436c-1.19 5.42-.916 5.102-2.106 10.523z",
			fill: "#2f2e41"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M495.39 174h-156a17.02 17.02 0 01-17-17V30a17.02 17.02 0 0117-17h156a17.02 17.02 0 0117 17v127a17.02 17.02 0 01-17 17zm-156-159a15.017 15.017 0 00-15 15v127a15.017 15.017 0 0015 15h156a15.017 15.017 0 0015-15V30a15.017 15.017 0 00-15-15z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 411",
			d: "M477.658 51.138h-78.73a2.73 2.73 0 01-2.777-2.49 2.63 2.63 0 012.627-2.771h80.144c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 412",
			d: "M477.658 64.948h-78.73a2.73 2.73 0 01-2.777-2.49 2.63 2.63 0 012.627-2.771h80.144c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M381.907 72.811H357.88a2.962 2.962 0 01-2.959-2.959V41.497a2.962 2.962 0 012.96-2.959h24.027a2.963 2.963 0 012.96 2.959v28.355a2.962 2.962 0 01-2.96 2.959z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 414",
			d: "M477.43 93.224H357.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 415",
			d: "M477.43 107.038H357.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 416",
			d: "M477.43 120.843H357.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 417",
			d: "M477.43 134.656H357.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 418",
			d: "M477.43 148.462H357.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M461.39 0a5.006 5.006 0 015 5v16a5.006 5.006 0 01-5 5h-88a5.006 5.006 0 01-5-5V5a5.006 5.006 0 015-5",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M720.39 331h-156a17.02 17.02 0 01-17-17V187a17.02 17.02 0 0117-17h156a17.02 17.02 0 0117 17v127a17.02 17.02 0 01-17 17zm-156-159a15.017 15.017 0 00-15 15v127a15.017 15.017 0 0015 15h156a15.017 15.017 0 0015-15V187a15.017 15.017 0 00-15-15z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 411",
			d: "M702.658 208.138h-78.73a2.73 2.73 0 01-2.777-2.49 2.63 2.63 0 012.627-2.771h80.144c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 412",
			d: "M702.658 221.948h-78.73a2.73 2.73 0 01-2.777-2.49 2.63 2.63 0 012.627-2.771h80.144c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M606.907 229.811H582.88a2.962 2.962 0 01-2.959-2.959v-28.355a2.962 2.962 0 012.96-2.959h24.027a2.963 2.963 0 012.96 2.959v28.355a2.962 2.962 0 01-2.96 2.959z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 413",
			d: "M701.907 306.811H677.88a2.962 2.962 0 01-2.959-2.959v-16.355a2.962 2.962 0 012.96-2.959h24.027a2.963 2.963 0 012.96 2.959v16.355a2.962 2.962 0 01-2.96 2.959z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 414",
			d: "M702.43 250.224H582.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 415",
			d: "M702.43 264.038H582.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 416",
			d: "M702.43 277.843H582.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h121.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 417",
			d: "M639.43 291.656H582.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h58.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			"data-name": "Path 418",
			d: "M639.43 305.462H582.27a2.73 2.73 0 01-2.776-2.489 2.63 2.63 0 012.627-2.772h58.572c2.64 2.32 1.031 5.261-1.265 5.261z",
			fill: "#ccc"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M686.39 183h-88a5.006 5.006 0 01-5-5v-16a5.006 5.006 0 015-5h88a5.006 5.006 0 015 5v16a5.006 5.006 0 01-5 5z",
			fill: "#6c63ff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M382 544H1a1 1 0 010-2h381a1 1 0 010 2z",
			fill: "#3f3d56"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 96.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 96.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 96.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 96.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 123.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 150.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 177.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 204.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 204.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 204.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 204.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231.764,
			cy: 23.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231.764,
			cy: 49.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231.764,
			cy: 74.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 231.764,
			cy: 100.644,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 601.764,
			cy: 381.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 601.764,
			cy: 407.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 601.764,
			cy: 432.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 628.764,
			cy: 381.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 628.764,
			cy: 407.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 628.764,
			cy: 432.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 655.764,
			cy: 381.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 655.764,
			cy: 407.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 655.764,
			cy: 432.871,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 682.764,
			cy: 381.324,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 682.764,
			cy: 407.098,
			r: 6.467,
			fill: "#f2f2f2"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 682.764,
			cy: 432.871,
			r: 6.467,
			fill: "#f2f2f2"
		})
	]
});
export default SvgUndrawTakingNotes;
